import React, { useEffect, useState } from "react";
import { getMyFilesList, addMyFilesKeywords, deleteMyFilesKeywords, updateMyFilesDocumentsType } from "../../../services/AdminService";
import { FaTimes } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const MyFilesTable = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});
  const [tagModal, setTagModal] = useState(false);
  const [docTypeModal, setDocTypeModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [modalKeywords, setModalKeywords] = useState([]);
  const [tagInputs, setTagInputs] = useState({});
  const [errorMessages, setErrorMessages] = useState({});
  const [docTypeInput, setDocTypeInput] = useState("");
  const MAX_KEYWORDS = 15;


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getMyFilesList()
      .then(response => {
        if (response.data.message === "success") {
          setFiles(response.data.data);
        }
      })
      .catch(error => {
        console.error("Error fetching files:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = files.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(files.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const toggleExpand = (fileId) => {
    setExpandedRows(prev => ({ ...prev, [fileId]: !prev[fileId] }));
  };

  const handleOpenTagModal = (file) => {
    setSelectedFile(file);
    const keywords = Array.isArray(file.keywords)
      ? file.keywords
      : file.keywords ? file.keywords.split(",").map(k => k.trim()) : [];
    setModalKeywords(keywords);
    setTagModal(true);
  };

  const handleCloseTagModal = () => {
    setTagModal(false);
    setSelectedFile(null);
    setModalKeywords([]);
    setTagInputs({});
    setErrorMessages({});
  };

  const handleOpenDocTypeModal = (file) => {
    setSelectedFile(file);
    setDocTypeInput(file.document_type || "");
    setDocTypeModal(true);
  };

  const handleCloseDocTypeModal = () => {
    setDocTypeModal(false);
    setSelectedFile(null);
    setDocTypeInput("");
  };

  const handleKeyPress = (e, fileId) => {
    if (e.key === "Enter") {
      saveKeyword(fileId, tagInputs[fileId]);
    }
  };

  const saveKeyword = (fileId, keywordValue) => {
    const trimmedKeywordValue = keywordValue?.trim();
    if (!trimmedKeywordValue) return;

    if (modalKeywords.includes(trimmedKeywordValue)) {
      setErrorMessages(prev => ({ ...prev, [fileId]: "This keyword already exists!" }));
      return;
    }

    if (modalKeywords.length >= MAX_KEYWORDS) {
      setErrorMessages(prev => ({ ...prev, [fileId]: `You can add a maximum of ${MAX_KEYWORDS} keywords!` }));
      return;
    }

    setModalKeywords(prev => [...prev, trimmedKeywordValue]);
    setTagInputs(prev => ({ ...prev, [fileId]: "" }));
    setErrorMessages(prev => ({ ...prev, [fileId]: "" }));

    const data = { user_id: selectedFile.user_id, file_id: fileId, keyword: trimmedKeywordValue };
    addMyFilesKeywords(data)
      .then(() => {
        setFiles(prevFiles =>
          prevFiles.map(file =>
            file.id === fileId
              ? { ...file, keywords: [...modalKeywords, trimmedKeywordValue] }
              : file
          )
        );
      })
      .catch(() => {
        setModalKeywords(prev => prev.filter(k => k !== trimmedKeywordValue));
        setErrorMessages(prev => ({ ...prev, [fileId]: "Error adding keyword. Please try again." }));
      });
  };

  const removeKeyword = (file, keyword) => {
    if (tagModal && selectedFile.id === file.id) {
      setModalKeywords(prev => prev.filter(k => k !== keyword));
    }

    const data = { user_id: file.user_id, file_id: file.id, keyword };
    deleteMyFilesKeywords(data)
      .then(() => {
        setFiles(prevFiles =>
          prevFiles.map(f =>
            f.id === file.id
              ? {
                ...f,
                keywords: Array.isArray(f.keywords)
                  ? f.keywords.filter(k => k !== keyword)
                  : []
              }
              : f
          )
        );
      })
      .catch(error => {
        console.error("Error removing keyword:", error);
        if (tagModal && selectedFile.id === file.id) {
          setModalKeywords(prev => [...prev, keyword]);
        }
        setErrorMessages(prev => ({ ...prev, [file.id]: "Error removing keyword. Please try again." }));
      });
  };

  const updateDocumentType = () => {
    if (!docTypeInput.trim()) {
      setErrorMessages(prev => ({ ...prev, [selectedFile.id]: "Document type cannot be empty!" }));
      return;
    }

    const data = { user_id: selectedFile.user_id, file_id: selectedFile.id, document_type: docTypeInput };
    updateMyFilesDocumentsType(data)
      .then(() => {
        setFiles(prevFiles =>
          prevFiles.map(file =>
            file.id === selectedFile.id
              ? { ...file, document_type: docTypeInput }
              : file
          )
        );
        handleCloseDocTypeModal();
      })
      .catch(error => {
        console.error("Error updating document type:", error);
        setErrorMessages(prev => ({ ...prev, [selectedFile.id]: "Error updating document type. Please try again." }));
      });
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <div className="bg-white">
        <div style={{ overflowX: "auto", width: "100%", scrollbarWidth: "thin" }}>
          <table
            style={{
              borderCollapse: "collapse",
              minWidth: "1330px",
              width: "100%",
              border: "1px solid #ddd",
            }}
          >
            <thead className="fs-5">
              <tr>
                <th style={{ width: "300px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>File Name</th>
                <th style={{ width: "100px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>File Size</th>
                <th style={{ width: "150px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Document Type</th>
                <th style={{ width: "350px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Keywords</th>
                <th style={{ width: "120px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Upload Date</th>
                <th style={{ width: "50px", border: "1px solid #ddd", padding: "8px", textAlign: "center" }}><i className="bi bi-three-dots-vertical" /></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map(file => {
                const keywords = Array.isArray(file.keywords)
                  ? file.keywords
                  : file.keywords ? file.keywords.split(",").map(k => k.trim()) : [];

                return (
                  <tr key={file.id}>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{file.file_name}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                      {(file.file_size / 1024).toFixed(2)} MB
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                      {file.document_type || "N/A"}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                          {keywords.length > 0 ? (
                            <>
                              {keywords.slice(0, expandedRows[file.id] ? keywords.length : 2).map((keyword, idx) => (
                                <span
                                  key={idx}
                                  className="badge bg-primary text-white me-2 position-relative keyword-item"
                                  style={{ padding: "5px 10px", }}
                                >
                                  {keyword}
                                  <FaTimes
                                    className="cursor-pointer ms-1 text-dark"
                                    onClick={() => removeKeyword(file, keyword)}
                                  />
                                </span>
                              ))}
                            </>
                          ) : (
                            <span>No keywords</span>
                          )}
                        </div>
                        {keywords.length > 2 && (
                          <span
                            className="show-more text-primary"
                            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                            onClick={() => toggleExpand(file.id)}
                          >
                            {expandedRows[file.id] ? "Show Less" : `Show More (${keywords.length - 2})`}
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                      {file.upload_date ? new Date(file.upload_date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) : "N/A"}
                    </td>
                    <td style={{ border: "1px solid #ddd", textAlign: "center" }} className="functional_icons">
                      <div className="dropdown">
                        <span
                          className="functional_icon_ellipsis"
                          id={`dropdownMenuButton-${file.id}`}
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="bi bi-three-dots-vertical" />
                        </span>
                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${file.id}`}>
                          <li>
                            <span
                              className="dropdown-item cur-pointer"
                              onClick={() => handleOpenTagModal(file)}
                            >
                              Add Tag
                            </span>
                          </li>
                          <li>
                            <span
                              className="dropdown-item cur-pointer"
                              onClick={() => handleOpenDocTypeModal(file)}
                            >
                              Update Document Type
                            </span>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* Tag Modal */}
        {tagModal && (
          <div className="tag-modal-overlay">
            <div className="tag-modal-content">
              <div className="tag-modal-header">
                <h4>Manage Tags</h4>
                <button onClick={handleCloseTagModal}>
                  <FaTimes />
                </button>
              </div>
              <hr style={{ margin: "0", border: "1px solid #ddd" }} />
              <div className="tag-modal-body" style={{ padding: "20px" }}>
                {selectedFile && (
                  <>
                    <div className="mb-3">
                      <strong>File:</strong> {selectedFile.file_name}
                    </div>
                    <div className="mb-3">
                      <strong className="me-2">Keywords ({modalKeywords.length}/{MAX_KEYWORDS}):</strong>
                      {modalKeywords.length > 0 ? (
                        modalKeywords.map((keyword, index) => (
                          <span key={index} className="badge bg-primary text-white me-2 mb-2">
                            {keyword}
                            <FaTimes
                              className="cursor-pointer ms-1"
                              onClick={() => removeKeyword(selectedFile, keyword)}
                            />
                          </span>
                        ))
                      ) : (
                        <span className="text-muted">No keywords</span>
                      )}
                    </div>
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter tag name"
                        value={tagInputs[selectedFile.id] || ""}
                        onChange={e => setTagInputs(prev => ({ ...prev, [selectedFile.id]: e.target.value }))}
                        onKeyPress={e => handleKeyPress(e, selectedFile.id)}
                      />
                    </div>
                    {errorMessages[selectedFile.id] && <p className="text-danger pb-2">{errorMessages[selectedFile.id]}</p>}
                    <button
                      className="btn btn-primary"
                      onClick={() => saveKeyword(selectedFile.id, tagInputs[selectedFile.id])}
                    >
                      Add
                    </button>
                  </>
                )}
              </div>
              <hr style={{ margin: "0", border: "1px solid #ddd" }} />
              <div className="tag-modal-footer">
                <button onClick={handleCloseTagModal} className="btn btn-secondary">Close</button>
              </div>
            </div>
          </div>
        )}

        {/* Document Type Update Modal */}
        {docTypeModal && (
          <div className="doc-type-modal-overlay">
            <div className="doc-type-modal-content">
              <div className="doc-type-modal-header">
                <h4>Update Document Type</h4>
                <button onClick={handleCloseDocTypeModal}>
                  <FaTimes />
                </button>
              </div>
              <hr style={{ margin: "0", border: "1px solid #ddd" }} />
              <div className="doc-type-modal-body" style={{ padding: "20px" }}>
                {selectedFile && (
                  <>
                    <div className="mb-3">
                      <strong>File:</strong> {selectedFile.file_name}
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="docTypeInput mb-5">Document Type:</label>
                      <input
                        type="text"
                        id="docTypeInput"
                        className="form-control mt-2"
                        value={docTypeInput}
                        onChange={e => setDocTypeInput(e.target.value)}
                        placeholder="Enter document type"
                      />
                    </div>
                    {errorMessages[selectedFile.id] && <p className="text-danger">{errorMessages[selectedFile.id]}</p>}

                  </>
                )}
              </div>
              <hr style={{ margin: "0", border: "1px solid #ddd" }} />
              <div className="modal-footer my-2">
                <button
                  className="btn btn-primary"
                  onClick={updateDocumentType}
                >
                  Update
                </button>
                <button onClick={handleCloseDocTypeModal} className="btn btn-secondary">Close</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Pagination Section */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="d-flex align-items-center">
          <p className="fw-bolder me-3 fs-5 text-white">Show</p>
          <select
            className="form-select"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            style={{ width: "80px" }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage(prev => (prev > 1 ? prev - 1 : prev))}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPage(prev => (prev < totalPages ? prev + 1 : prev))}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </>
  );
};

export default MyFilesTable;